"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createAsyncReducers = createAsyncReducers;
exports.createDeleteAsyncReducers = createDeleteAsyncReducers;
exports.createGetAsyncReducers = createGetAsyncReducers;
exports.createPatchAsyncReducers = createPatchAsyncReducers;
exports.createPostAsyncReducers = createPostAsyncReducers;
exports.createPutAsyncReducers = createPutAsyncReducers;
const ActionMethods_1 = require("../types/ActionMethods.js");
const types_1 = require("../status/types.js");
const lib_1 = require("../actionTypes/lib.js");
const lib_2 = require("../state/lib.js");
const sonar_http_1 = require("@sonar-software/sonar-http");
function createAsyncReducers(options) {
    const defaultState = (0, lib_2.createAsyncState)();
    const errorTypeValue = (0, lib_1.createAsyncActionTypeValue)(Object.assign({ actionMethod: ActionMethods_1.AsyncActionMethods.Error }, options));
    const failedTypeValue = (0, lib_1.createAsyncActionTypeValue)(Object.assign({ actionMethod: ActionMethods_1.AsyncActionMethods.Failed }, options));
    const receiveTypeValue = (0, lib_1.createAsyncActionTypeValue)(Object.assign({ actionMethod: ActionMethods_1.AsyncActionMethods.Receive }, options));
    const requestTypeValue = (0, lib_1.createAsyncActionTypeValue)(Object.assign({ actionMethod: ActionMethods_1.AsyncActionMethods.Request }, options));
    const resetTypeValue = (0, lib_1.createAsyncActionTypeValue)(Object.assign({ actionMethod: ActionMethods_1.AsyncActionMethods.Reset }, options));
    const asyncReducer = function (state = defaultState, action) {
        const { statusCode, type } = action;
        switch (type) {
            case errorTypeValue:
                return Object.assign(Object.assign({}, state), (0, lib_2.createAsyncState)({
                    actionStatus: types_1.AsyncStateStatus.Errored,
                    data: undefined,
                    statusCode
                }));
            case failedTypeValue:
                return Object.assign(Object.assign({}, state), (0, lib_2.createAsyncState)({
                    actionStatus: types_1.AsyncStateStatus.Failed,
                    data: undefined,
                    statusCode
                }));
            case receiveTypeValue:
                return Object.assign(Object.assign({}, state), (0, lib_2.createAsyncState)({
                    actionStatus: types_1.AsyncStateStatus.Received,
                    data: (action === null || action === void 0 ? void 0 : action.data) ? action.data : undefined,
                    statusCode
                }));
            case requestTypeValue:
                return Object.assign(Object.assign({}, state), (0, lib_2.createAsyncState)({
                    actionStatus: types_1.AsyncStateStatus.Requested,
                    data: options.retainDataOnRequest ? state.data : undefined,
                    statusCode: undefined
                }));
            case resetTypeValue:
                return Object.assign(Object.assign({}, state), (0, lib_2.createAsyncState)({
                    actionStatus: types_1.AsyncStateStatus.Idle,
                    data: undefined,
                    statusCode: undefined
                }));
            case 'reset':
                return defaultState;
            default:
                return state;
        }
    };
    return asyncReducer;
}
function createDeleteAsyncReducers(options) {
    return createAsyncReducers(Object.assign(Object.assign({}, options), { httpVerb: sonar_http_1.HttpVerb.Delete }));
}
function createGetAsyncReducers(options) {
    return createAsyncReducers(Object.assign(Object.assign({}, options), { httpVerb: sonar_http_1.HttpVerb.Get }));
}
function createPatchAsyncReducers(options) {
    return createAsyncReducers(Object.assign(Object.assign({}, options), { httpVerb: sonar_http_1.HttpVerb.Patch }));
}
function createPostAsyncReducers(options) {
    return createAsyncReducers(Object.assign(Object.assign({}, options), { httpVerb: sonar_http_1.HttpVerb.Post }));
}
function createPutAsyncReducers(options) {
    return createAsyncReducers(Object.assign(Object.assign({}, options), { httpVerb: sonar_http_1.HttpVerb.Put }));
}
//# sourceMappingURL=lib.js.map